import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  MenuList,
  ListItemButton,
  ListItemText,
  styled,
} from "@mui/material";
import { useDispatch } from "react-redux";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import FolderIcon from "@mui/icons-material/Folder";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import FilterAutocomplete from "../shared/AutoCompeleteFillter";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  marginTop: "5px !important",
  "&:before": {
    display: "none",
  },
}));

const CustomTypography = styled((props) => <Typography {...props} />)(() => ({
  color: "#50566E",
  fontSize: ".875rem",
  fontWeight: "bold",
  lineheight: "16px",
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  boxSizing: "border-box",
  height: "34px",
  minHeight: "34px",
  borderTop: "1px solid #CFD7DF",
  borderBottom: "1px solid #CFD7DF",
  backgroundColor: "#F2F4F8",
  flexDirection: "row-reverse",
  paddingRight: theme.spacing(0),
  paddingLeft: theme.spacing(0),
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(270deg)",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    transform: "rotate(90deg)",
    color: "#50566E",
    fontSize: ".875rem",
    fontWeight: "600",
  },
  "& .MuiAccordionSummary-content": {
    color: "#50566E",
    fontSize: ".875rem",
    fontWeight: "550",
    lineheight: "16px",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingRight: theme.spacing(0),
  paddingLeft: theme.spacing(0),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const AlertTable = ({
  alerts,
  current,
  messageTypes,
  touched,
  setIsConfirmationModalOpen,
  setPendingCurrentLicense,
}) => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState("panel1");
  const [expanded2, setExpanded2] = useState("panel2");
  const [selectedMessageType, setSelectedMessageType] = useState({
    id: "SELECT",
    value: "select messageType",
    label: "select messageType",
  });

  const handleListItemClick = (item) => {
    if (item.id !== current?.id) {
      if (!touched) {
        dispatch({ type: "CURRENT_CRITERIA", payload: item });
      } else {
        setIsConfirmationModalOpen(true);
        setPendingCurrentLicense(item);
      }
    }
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleChange2 = (panel) => (event, newExpanded) => {
    setExpanded2(newExpanded ? panel : false);
  };
  const handleAddNew = (e, type) => {
    e.stopPropagation();

    if (current?.alertType === type && current.id === -1) return;

    let obj = {
      alertType: type,
      currency: null,
      id: -1,
      messageType: "",
      direction: null,
      messageField: "",
      operator: "",
      value: "",
      notificationType: "",
      timeOfDay: null,
      templateId: null,
      receivers: [],
      ccReceivers: [],
    };
    if (!touched) {
      dispatch({ type: "addnew", payload: type });
    } else {
      setIsConfirmationModalOpen(true);

      setPendingCurrentLicense(obj);
    }
  };

  useEffect(() => {
    if (alerts.Amount.length <= 0) {
      setExpanded(false);
    } else {
      setExpanded("panel1");
    }
    if (alerts.Text.length <= 0) {
      setExpanded2(false);
    } else {
      setExpanded2("panel2");
    }
  }, [alerts.Amount.length, alerts.Text.length]);
  const handeleChangeMessageType = (newvalue) => {
    setSelectedMessageType(newvalue);
    dispatch({ type: "Filter_Messages", payload: newvalue });
    dispatch({ type: "CURRENT_CRITERIA", payload: null });
  };

  return (
    <Grid
      container
      alignItems="center"
      direction="column"
      sx={{ minHeight: "600px" }}
    >
      <Grid item xs={12} sx={{ width: "100%", padding: "15px" }}>
        <FilterAutocomplete
          options={[
            { value: "All", label: "All", id: "All" },
            ...messageTypes?.map((type) => ({
              id: type.id,
              label: type.name,
              value: type.name,
            })),
          ]}
          fieldName="Message Type"
          width
          selectedValue={selectedMessageType}
          handleChangeSelection={handeleChangeMessageType}
        />
      </Grid>
      <Grid item sx={{ width: "100%" }}>
        {alerts.Amount.length >= 0 && (
          <Accordion
            expanded={expanded === `panel1`}
            onChange={handleChange(`panel1`)}
          >
            <AccordionSummary
              expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
              aria-controls={`panel1-content`}
              id={`panel1-header`}
            >
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Grid item>
                  <Grid container alignItems="center">
                    <Grid item>
                      <FolderIcon
                        sx={{
                          fontSize: "1.5rem",
                          paddingTop: "5px",
                          verticalAlign: "inherit",
                        }}
                      />
                    </Grid>
                    <Grid item sx={{ marginLeft: "5px" }}>
                      <CustomTypography>Amount</CustomTypography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {React.Children.toArray(
                alerts.Amount.map((item, index) => (
                  <ListItemButton
                    key={item.id}
                    sx={{
                      maxHeight: "32px",
                      height: "32px",
                      width: "100%",
                      borderRadius: "4px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      "&.Mui-selected": {
                        backgroundColor: "#1492AF !important",
                        color: "#fff !imporant",
                      },

                      // backgroundColor:
                      //   pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                    onClick={() => handleListItemClick(item)}
                    selected={expanded ? current?.id === item.id : false}
                  >
                    <Grid container alignItems="center">
                      <Grid item>
                        <Grid
                          container
                          alignItems="center"
                          sx={{ marginLeft: "20px" }}
                        >
                          <Grid item>
                            <FolderIcon
                              size="small"
                              fontSize="1.875rem"
                              sx={{
                                color:
                                  current?.id === item.id ? "#fff" : "#50566E",
                                verticalAlign: "baseline",
                                fontSize: "1.1rem",
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <ListItemText
                              sx={{
                                // color: pathname === item.path ? "#1492AF" : "#050D2E",
                                // "& .MuiTypography-root": {
                                //   fontWeight: pathname === item.path ? "550" : "400",
                                // },
                                color:
                                  current?.id === item.id ? "#fff" : "#50566E",
                                "& .MuiTypography-root": {
                                  fontWeight: "bold",
                                  fontSize: ".875rem",
                                },
                                marginLeft: "5px",
                              }}
                            >
                              {item.name}
                            </ListItemText>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItemButton>
                ))
              )}
              <Grid
                item
                sx={{
                  color: "#007AFF",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: "14px",
                  textDecoration: "underline",
                  padding: "15px",
                }}
                onClick={(e) => handleAddNew(e, "AMOUNT")}
              >
                + Add New Criteria
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        {alerts.Text.length >= 0 && (
          <Accordion
            expanded={expanded2 === `panel2`}
            onChange={handleChange2(`panel2`)}
          >
            <AccordionSummary
              expandIcon={<ArrowRightIcon sx={{ fontSize: "1.8rem" }} />}
              aria-controls={`panel2-content`}
              id={`panel2-header`}
            >
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Grid item>
                  <Grid container alignItems="center">
                    <Grid item>
                      <FolderIcon
                        sx={{
                          fontSize: "1.5rem",
                          paddingTop: "5px",
                          verticalAlign: "inherit",
                        }}
                      />
                    </Grid>
                    <Grid item sx={{ marginLeft: "5px" }}>
                      <CustomTypography>Text</CustomTypography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {React.Children.toArray(
                alerts.Text.map((item, index) => (
                  <ListItemButton
                    sx={{
                      maxHeight: "32px",
                      height: "32px",
                      width: "100%",
                      borderRadius: "4px",
                      "&:hover": { backgroundColor: "#D4EDF3" },
                      "&.Mui-selected": {
                        backgroundColor: "#1492AF !important",
                        color: "#fff !imporant",
                      },

                      // backgroundColor:
                      //   pathname === item.path ? "#D4EDF3" : "#fffff",
                    }}
                    onClick={() => handleListItemClick(item)}
                    selected={expanded2 ? current?.id === item.id : false}
                  >
                    <Grid container alignItems="center">
                      <Grid item>
                        <Grid
                          container
                          alignItems="center"
                          sx={{ marginLeft: "20px" }}
                        >
                          <Grid item>
                            <FolderIcon
                              size="small"
                              fontSize="1.875rem"
                              sx={{
                                color:
                                  current?.id === item.id ? "#fff" : "#50566E",
                                verticalAlign: "baseline",
                                fontSize: "1.1rem",
                              }}
                            />
                          </Grid>
                          <Grid item>
                            <ListItemText
                              sx={{
                                // color: pathname === item.path ? "#1492AF" : "#050D2E",
                                // "& .MuiTypography-root": {
                                //   fontWeight: pathname === item.path ? "550" : "400",
                                // },
                                color:
                                  current?.id === item.id ? "#fff" : "#50566E",
                                "& .MuiTypography-root": {
                                  fontWeight: "bold",
                                  fontSize: ".875rem",
                                },
                                marginLeft: "5px",
                              }}
                            >
                              {item.name}
                            </ListItemText>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItemButton>
                ))
              )}
              <Grid
                item
                sx={{
                  color: "#007AFF",
                  cursor: "pointer",
                  fontWeight: "500",

                  fontSize: "14px",
                  textDecoration: "underline",
                  padding: "15px",
                }}
                onClick={(e) => handleAddNew(e, "TEXT")}
              >
                + Add New Criteria
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

        <MenuList>
          {/*     { alerts && alerts.map((license) => {
            return (
              <ListItemButton
                key={license.key}
                sx={{
                  padding: "8px",
                  maxHeight: "36px",
                  height: "36px",
                  width: "100%",
                  "&:hover": { backgroundColor: "#D4EDF3" },
                  backgroundColor:
                    currentLicense.key === license.key ? "#D4EDF3" : "#fffff",
                  borderRadius: "4px",
                }}
                onClick={handleItemClick}
                id={license.key}
              >
                {license.isNew ? (
                  <>
                    <OutlinedInput
                      id={formik.values.uniqueId}
                      sx={{
                        height: "25px",
                        width: "100%",
                        "& .MuiInputBase-root": {
                          height: "25px",
                        },
                        "& .MuiOutlinedInput": {
                          height: "25px",
                        },
                        backgroundColor: "#ffffff",
                      }}
                      value={formik.values.licenseName}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.licenseName)}
                      placeholder="License Name"
                      name="licenseName"
                    />
                  </>
                ) : (
                  <ListItemText
                    sx={{
                      color:
                        currentLicense.key === license.key
                          ? "#1492AF"
                          : "#050D2E",
                      "& .MuiTypography-root": {
                        fontWeight:
                          currentLicense.key === license.key ? "550" : "400",
                      },
                    }}
                  >
                    {license.licenseName}
                  </ListItemText>
                )}
              </ListItemButton>
            );
          })} */}
        </MenuList>
      </Grid>
    </Grid>
  );
};

export default AlertTable;
